import moment from 'moment';

export const BASE_URL_API =
  process.env.NODE_ENV === 'development'
    ? String(process.env.REACT_APP_DEV_MODE)
    : String(process.env.REACT_APP_PRO_MODE);

export const BASE_URL_APP =
  process.env.NODE_ENV === 'development'
    ? String(process.env.REACT_APP_PRIVATE_DEV_MODE)
    : String(process.env.REACT_APP_PRIVATE_PRO_MODE);

export const BASE_HOSTNAME =
  process.env.NODE_ENV === 'development'
    ? String(process.env.HOSTNAME_DEV)
    : String(process.env.HOSTNAME_PRO);

export function clearHtmlFromString(html: string): string {
  let text = html.replace(/<[^>]*>/g, '').trim();

  const entities: { [key: string]: string } = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&apos;': "'",
    '&nbsp;': ' ',
  };

  text = text.replace(/&[a-zA-Z0-9#]+;/g, (entity) => entities[entity] || entity);

  return text;
}

export const formatDate = (
  date: Date | string | undefined,
  format?: string
) => {
  return moment(date)?.format(format ?? 'DD.MM.YYYY');
};

export function getCampaignDurationLabel(
    duration: string
): string {
  const months = Number(duration.split('_')[1]);

  if (Number.isNaN(months)) return '';

  return `${months} month${months > 1 ? 's' : ''}`;
}


